/* tslint:disable: jsx-no-lambda*/
import { __ } from 'react-i18n/lib';
import {
  ErrorAlert,
  FlexColCenterVertical,
  FlexRow,
  FlexRowCenter,
  InfoText,
} from '../../..';
import { CheckBox } from '../General/Checkbox';
import { InfoType } from '../../Zemplin/General/InfoText';
import { LoginButton, Header, Form, Wrapper } from '../General/Auth';
import { FormInput, FormWrapper } from '../Form/FormInput';
import { Loader } from '../../Zemplin/General/Loader';
import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Select } from '../../Zemplin/General/Select';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { B2BRegisterFormFields } from './types';
import { emailIsValid } from '../../../utilities';

interface Props {
  handleFormSubmit: (
    fields: B2BRegisterFormFields,
    isCompanyAgreed: boolean,
    isGdprAccepted: boolean,
    isNewsletterAccepted: boolean,
  ) => void;
  isFetching: boolean;
  successMessage: string;
  errorMessage: string;
}

const SLOVAKIA = { value: 'sk', name: 'Slovensko' };

const COUNTRIES: Array<{ value: string; name: string }> = [SLOVAKIA];

type event = React.ChangeEvent<HTMLInputElement>;

const validFields = (
  fields: B2BRegisterFormFields,
  isGdprAccepted: boolean,
  isCompanyAgreed: boolean,
): boolean => {
  if (!isGdprAccepted || !isCompanyAgreed) {
    return false;
  }

  if (
    !fields.billing_address ||
    !fields.company ||
    !fields.email ||
    !fields.name ||
    !fields.password ||
    !fields.passwordAgain ||
    !fields.phone ||
    !fields.surname
  ) {
    return false;
  }

  if (
    !fields.billing_address.city ||
    !fields.billing_address.country ||
    !fields.billing_address.name ||
    !fields.billing_address.number ||
    !fields.billing_address.street ||
    !fields.billing_address.surname ||
    !fields.billing_address.zip
  ) {
    return false;
  }

  if (!fields.company.ic_dph || !fields.company.ico || !fields.company.name) {
    return false;
  }

  if (!emailIsValid(fields.email)) {
    return false;
  }

  return true;
};

function B2BRegisterForm({
  handleFormSubmit,
  isFetching,
  successMessage,
  errorMessage,
}: Props) {
  const [fields, setFields] = React.useState<B2BRegisterFormFields>({
    name: '',
    surname: '',
    email: '',
    phone: '',
    password: '',
    passwordAgain: '',
    company: {
      name: '',
      ico: '',
      dic: '',
      ic_dph: '',
    },
    billing_address: {
      name: '',
      surname: '',
      street: '',
      number: '',
      city: '',
      zip: '',
      country: SLOVAKIA,
    },
  });

  const [isCompanyAgreed, setIsCompanyAgreed] = React.useState<boolean>(false);
  const [isGdprAccepted, setIsGdprAccepted] = React.useState<boolean>(false);
  const [isNewsletterAccepted, setIsNewsletterAccepted] = React.useState<
    boolean
  >(false);

  const titleRef = React.useRef<HTMLDivElement>(null);

  const setBasicField = (name: string, e: event): void => {
    setFields({ ...fields, [name]: e.target.value });
  };

  const setCompanyField = (name: string, e: event): void => {
    setFields({
      ...fields,
      company: { ...fields.company, [name]: e.target.value },
    });
  };

  const setBillingAddresField = (name: string, e: event): void => {
    setFields({
      ...fields,
      billing_address: { ...fields.billing_address, [name]: e.target.value },
    });
  };

  const submitForm = e => {
    e.preventDefault();

    if (titleRef.current) {
      titleRef.current.scrollIntoView();
    }
    handleFormSubmit(
      fields,
      isCompanyAgreed,
      isGdprAccepted,
      isNewsletterAccepted,
    );
  };

  return (
    <StyledWrapper>
      <div ref={titleRef} />
      <Header>{`${__('Chcem sa stať veľkoobchodným partnerom')}`}</Header>
      {successMessage && (
        <InfoText type={InfoType.SUCCESS} info={successMessage} />
      )}
      <Form onSubmit={submitForm}>
        <CheckBox
          name={'warehouse'}
          type={'checkbox'}
          selected={isCompanyAgreed}
          onClick={() => setIsCompanyAgreed(!isCompanyAgreed)}
          label={__(
            'Prehlasujeme, že sme obchodná spoločnosť alebo firma, ktorá bude opakovane nakupovať Vami ponúkané produkty a náš predpokladaný nákup za rok bude presahovať minimálne 1 500,- €. Súhlasíme s tým, že poskytnutím týchto údajov nám nevzniká automaticky nárok na získanie podmienok k veľkoobchodnej spolupráci a toto rozhodnutie je v plne kompetencii ZEMPLÍN, s.r.o.. ',
          )}
        />
        <div>
          {errorMessage && (
            <>
              <ErrorAlert
                style={{ marginTop: rem(32) }}
                message={errorMessage}
              />
              <br />
            </>
          )}
        </div>
        <SubTitle>{`${__('Kontaktné údaje')}`}</SubTitle>
        <RowInput>
          <FormInput
            type="text"
            name={'name'}
            label={__('Meno')}
            required={true}
            marginBottom={0}
            marginRight={32}
            minWidthPx={320}
            onChange={(e: event) => setBasicField('name', e)}
            value={fields.name}
          />
          <FormInput
            type="text"
            name={'surname'}
            required={true}
            label={__('Priezvisko')}
            marginBottom={0}
            minWidthPx={320}
            onChange={(e: event) => setBasicField('surname', e)}
            value={fields.surname}
          />
        </RowInput>
        <RowInput>
          <FormInput
            type="email"
            name={'email'}
            label={__('Email')}
            required={true}
            marginBottom={0}
            marginRight={32}
            minWidthPx={320}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={(e: event) => setBasicField('email', e)}
            value={fields.email}
          />
          <FormInput
            type="text"
            name={'phone'}
            required={true}
            label={__('Tel. číslo')}
            marginBottom={0}
            placeholder={__('Napíšte v tvare +421915555666')}
            minWidthPx={320}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={(e: event) => setBasicField('phone', e)}
            value={fields.phone}
          />
        </RowInput>
        <RowInput>
          <FormInput
            type="password"
            name={'password'}
            required={true}
            label={__('Heslo')}
            marginBottom={16}
            marginRight={32}
            minWidthPx={320}
            onChange={(e: event) => setBasicField('password', e)}
            value={fields.password}
          />
          <FormInput
            type="password"
            name={'passwordAgain'}
            required={true}
            label={__('Potvrdenie hesla')}
            marginBottom={16}
            minWidthPx={320}
            onChange={(e: event) => setBasicField('passwordAgain', e)}
            value={fields.passwordAgain}
          />
        </RowInput>

        <SubTitle>{`${__('Fakturačná adresa')}`}</SubTitle>
        <RowInput>
          <FormInput
            type="text"
            name={'billingName'}
            label={__('Meno')}
            required={true}
            marginBottom={0}
            marginRight={32}
            minWidthPx={320}
            onChange={(e: event) => setBillingAddresField('name', e)}
            value={fields.billing_address.name}
          />
          <FormInput
            type="text"
            name={'billingSurname'}
            required={true}
            label={__('Priezvisko')}
            marginBottom={0}
            minWidthPx={320}
            onChange={(e: event) => setBillingAddresField('surname', e)}
            value={fields.billing_address.surname}
          />
        </RowInput>
        <AddressWrapper>
          <FormWrapper noWrap={true} marginRight={32}>
            <FormInput
              name="street"
              type="text"
              label={__('Ulica')}
              required={true}
              maxWidth={100}
              maxWidthPx={224}
              marginRight={16}
              marginBottom={0}
              onChange={(e: event) => setBillingAddresField('street', e)}
              value={fields.billing_address.street}
            />
            <FormInput
              name="street_number"
              type="text"
              label={__('Číslo')}
              required={true}
              maxWidth={34}
              maxWidthPx={80}
              marginBottom={0}
              onChange={(e: event) => setBillingAddresField('number', e)}
              value={fields.billing_address.number}
            />
          </FormWrapper>
          <FormWrapper noWrap={true}>
            <FormInput
              name="city"
              type="text"
              label={__('Mesto')}
              required={true}
              maxWidth={100}
              maxWidthPx={224}
              marginRight={16}
              marginBottom={0}
              onChange={(e: event) => setBillingAddresField('city', e)}
              value={fields.billing_address.city}
            />
            <FormInput
              name="zip"
              type="text"
              label={__('PSČ')}
              required={true}
              maxWidth={34}
              maxWidthPx={80}
              marginBottom={0}
              onChange={(e: event) => setBillingAddresField('zip', e)}
              value={fields.billing_address.zip}
            />
          </FormWrapper>{' '}
        </AddressWrapper>
        <Select
          marginBottom={16}
          name="country"
          label={__('Krajina')}
          value={fields.billing_address.country.value}
          options={COUNTRIES}
          onChange={(e: event) => setBillingAddresField('country', e)}
        />

        <FormInput
          type="text"
          name={'company_name'}
          label={__('Názov spoločnosti')}
          required={true}
          marginBottom={0}
          marginRight={32}
          minWidthPx={320}
          onChange={(e: event) => setCompanyField('name', e)}
          value={fields.company.name}
        />
        <FormInput
          type="text"
          name={'ico'}
          required={true}
          label={__('IČO')}
          marginBottom={0}
          minWidthPx={320}
          onChange={(e: event) => setCompanyField('ico', e)}
          value={fields.company.ico}
        />
        <FormInput
          type="text"
          name={'dic'}
          label={__('DIČ')}
          marginBottom={0}
          minWidthPx={320}
          onChange={(e: event) => setCompanyField('dic', e)}
          value={fields.company.dic}
        />
        <FormInput
          type="text"
          name={'ic_dph'}
          required={true}
          label={__('IČ DPH')}
          marginBottom={0}
          minWidthPx={320}
          onChange={(e: event) => setCompanyField('ic_dph', e)}
          value={fields.company.ic_dph}
        />
        <CheckBox
          name={'gdprAgree'}
          type={'checkbox'}
          selected={isGdprAccepted}
          required={true}
          label={
            <>
              {__('Súhlasím s')}{' '}
              <a
                target="__blank"
                rel="noopener noreferrer"
                href={'obchodne-podmienky'}
              >
                {__('obchodnými podmienkami')}
              </a>
              {__(' a oboznámil som sa so')}{' '}
              <a
                target="__blank"
                rel="noopener noreferrer"
                href={
                  'https://www.appgdpr.sk/doc/01HQR-J55AH-1XYK-2TZE-ZTZP-8WT3/DIP'
                }
              >
                {__('Zásadami ochrany OÚ')}
              </a>
            </>
          }
          wrapperStyle={{ marginTop: rem(32) }}
          onClick={() => setIsGdprAccepted(!isGdprAccepted)}
        />
        <CheckBox
          name={'newsletterAgree'}
          type={'checkbox'}
          selected={isNewsletterAccepted}
          label={
            <>
              {__('Súhlasím so zasielaním newslettra')}{' '}
              <a
                target="__blank"
                rel="noopener noreferrer"
                href={
                  'https://www.appgdpr.sk/doc/01HQR-HZY7T-JEEH-94V1-71NP-8HXP/DIP%20Vyhl%c3%a1senie%20o%20ochrane%20s%c3%bakromia%20-%20In%c3%a9%20[odberatelia%20newslettra].html'
                }
              >
                ({__('podmienky súhlasu')})
              </a>
            </>
          }
          wrapperStyle={{ marginTop: rem(16) }}
          onClick={() => setIsNewsletterAccepted(!isNewsletterAccepted)}
        />
        <StyledLoginButton
          disabled={
            isFetching || !validFields(fields, isGdprAccepted, isCompanyAgreed)
          }
          type="submit"
        >
          {isFetching ? (
            <FlexRowCenter>
              {`${__('Registrujem')}...`}
              <Loader className="marginLeft" small={true} />
            </FlexRowCenter>
          ) : (
            __('Odoslať žiadosť')
          )}
        </StyledLoginButton>
      </Form>
    </StyledWrapper>
  );
}

const StyledWrapper = styled(Wrapper)`
  max-width: ${rem(752)};
`;

const StyledLoginButton = styled(LoginButton)`
  max-width: ${rem(753)};
  margin-bottom: 0;
`;

const SubTitle = styled.h2`
  font-size: ${rem(30)};
  font-weight: 400;
  margin-top: ${rem(56)};
`;

export const RowInput = styled(FlexRow)<{
  maxWidth?: number;
  marginBottom: number;
}>`
  max-width: ${({ maxWidth }) => (maxWidth ? rem(maxWidth) : 'initial')};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? rem(marginBottom) : 0};
  ${({ theme }) => theme.mediab.m760`
        flex-direction: column;
    `}
`;

export const StyledInput = styled(FlexColCenterVertical)<{
  marginRight: number;
  marginBottom?: number;
}>`
  width: 100%;
  max-width: ${rem(345)};
  margin-right: ${({ marginRight }) => (marginRight ? rem(marginRight) : 0)};
  ${({ theme }) => theme.mediab.m760`
        max-width: ${rem(600)};
        margin-right: ${({ mobileMarginRight }) =>
          mobileMarginRight ? rem(mobileMarginRight) : 0}
    `};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? rem(marginBottom) : 'initial'};
`;

export const NumberInput = styled(StyledInput)`
  max-width: ${rem(80)};
  ${({ theme }) => theme.mediab.m760`
        max-width: ${rem(80)};
    `}
`;

export const StyledFlexRow = styled(FlexRow)`
  width: 100%;
`;

const AddressWrapper = styled(FlexRowCenterVertical)`
  flex-flow: row wrap;
`;

export { B2BRegisterForm };
